import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Popover from '@material-ui/core/Popover';
import ChangeStatePopoverContent from './ChangeStatePopoverContent';
import ChangeMaintenancePopoverContent from './ChangeMaintenancePopoverContent';
import { productionOrderStates as orderState } from '../../Config/productionOrderStates'
import { useTranslation } from 'react-i18next';
import EditOrderComponent from './EditOrderComponent';
import CreateOrderComponent from './CreateOrderComponent';
import Timer from '../Shared/Timer';

export default function EditCreateOrderDrawer(props) {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [state, setState] = useState(null);
    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)
    const [orderInfo, setOrderInfo] = useState([]);
    const [timer, setTimer] = useState(null)
    const [create, setCreate] = useState(false)
    const [changedState, setChangedState] = useState(false)
    const [maintenance, setMaintenance] = useState(false)

    const { t } = useTranslation();

    const open = Boolean(anchorEl);
    const open2 = Boolean(anchorEl2)
    const id = open ? 'simple-popover' : undefined;
    const id2 = open2 ? 'simple-popover' : undefined;

    useEffect(() => {
        let mounted = true
        clearInterval(timer)
        setTimer(null)
        if (mounted) {
            if (props.productionOrder) {
                if (state !== props.productionOrder.productionOrderStatus) {
                    setState(props.productionOrder.productionOrderStatus)
                }

                if (end !== props.productionOrder.finishedOnPlanned) {
                    setEnd(props.productionOrder.finishedOnPlanned)
                }
                if (start !== props.productionOrder.startedOnPlanned) {
                    setStart(props.productionOrder.startedOnPlanned)
                }

                if (maintenance !== JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].Maintenance) {
                    setMaintenance(JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].Maintenance)
                }
                let rows = []
                if (JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].Maintenance) {
                    rows = [createData('Machine/Line', "Line " + JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].MachineToMaintain),
                    createData('Description', JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0].MaintenanceDescription),
                    ]
                }
                else {
                    rows = [createData('Article', props.productionOrder.bomOut[0].productReference),
                    createData('Pieces', Math.round(props.productionOrder.bomOut[0].quantityToProduce)),
                    createData('Line', props.productionOrder.machinePlannedCode)]
                }
                setOrderInfo(rows)
                setCreate(false)
                setMaintenance(false)
            }
            else {
                setCreate(true)
                setStart(props.start)
                setEnd(props.end)
                setState(orderState.PLANNED)
            }
        }

        return function cleanup() {
            mounted = false
        }
    }, [props.productionOrder]);

    function saveOrder() {
        clearInterval(timer)
        setTimer(null)
        props.saveOrder(props.productionOrder.id, state, start, end)
        closeDrawer()
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClose2 = () => {
        setAnchorEl2(null);
    };

    function handleFromDateChange(date) {
        if (!create) {
            setStart(date.target.value)
        }
        else {
            props.setStart(date.target.value)
        }
    }

    function handleTillDateChange(date) {
        if (!create) {
            setEnd(date.target.value)
        }
        else {
            props.setEnd(date.target.value)
        }
    }

    function changeState(state) {
        setState(state)
        setAnchorEl(null)
    }

    const changeMaintenance = (maint) => {
        setMaintenance(maint)
        setAnchorEl2(null)
    }

    function createData(name, info) {
        return { name, info };
    }

    const closeDrawer = () => {
        if (props.productionOrder) {
            setState(props.productionOrder.productionOrderStatus)
        }
        props.openDrawer(false)
    }

    const splitOrder = () => {
        props.splitOrder(props.productionOrder)
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => closeDrawer()} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>
                    {props.productionOrder ? "Edit order" : "Create order"}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => closeDrawer()}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                {state ? <React.Fragment>
                    {props.productionOrder ? <React.Fragment><div className={classes.orderno}>
                        Ordern°
                    </div>
                        <div className={classes.article}>
                            {props.productionOrder.reference}
                        </div></React.Fragment> :
                        <React.Fragment></React.Fragment>}
                    <div>{create ?
                        <Button className={classes.stateButton} aria-describedby={id2} onClick={handleClick2}>
                            <div className={classes.stateIcon}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="26.329" height="26.329" viewBox="0 0 26.329 26.329"><defs></defs><g transform="translate(-48.368 -48.366)"><g transform="translate(48.518 48.516)"><g transform="translate(0 0)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M62.746,74.545H60.318a1.518,1.518,0,0,1-1.505-1.39l-.125-1.565a10.384,10.384,0,0,1-2.258-.938l-1.194,1.02a1.51,1.51,0,0,1-2.049-.08l-1.718-1.718a1.518,1.518,0,0,1-.082-2.047l1.02-1.2a10.406,10.406,0,0,1-.935-2.254l-1.565-.125a1.518,1.518,0,0,1-1.39-1.505V60.316a1.518,1.518,0,0,1,1.389-1.505l1.565-.125a10.382,10.382,0,0,1,.934-2.261l-1.017-1.19a1.518,1.518,0,0,1,.08-2.049l1.718-1.718a1.51,1.51,0,0,1,2.047-.082L56.43,52.4a10.409,10.409,0,0,1,2.258-.931l.125-1.565a1.518,1.518,0,0,1,1.505-1.389h2.428a1.518,1.518,0,0,1,1.505,1.389l.125,1.565a10.412,10.412,0,0,1,2.258.931l1.195-1.017a1.51,1.51,0,0,1,2.047.082l1.718,1.718a1.517,1.517,0,0,1,.08,2.049l-1.017,1.19a10.386,10.386,0,0,1,.934,2.261l1.565.125a1.518,1.518,0,0,1,1.39,1.505v2.428a1.518,1.518,0,0,1-1.39,1.505l-1.565.125a10.4,10.4,0,0,1-.935,2.254l1.02,1.2a1.518,1.518,0,0,1-.082,2.047l-1.718,1.718a1.51,1.51,0,0,1-2.049.08l-1.194-1.02a10.371,10.371,0,0,1-2.258.938l-.125,1.565A1.518,1.518,0,0,1,62.746,74.545Zm-6.358-4.728a.375.375,0,0,1,.192.053,9.632,9.632,0,0,0,2.554,1.061.376.376,0,0,1,.283.335l.147,1.83a.762.762,0,0,0,.755.7h2.428a.762.762,0,0,0,.755-.7l.147-1.83a.376.376,0,0,1,.283-.335,9.622,9.622,0,0,0,2.554-1.06.377.377,0,0,1,.437.037l1.4,1.193a.758.758,0,0,0,1.028-.04l1.718-1.718a.762.762,0,0,0,.041-1.027l-1.192-1.4a.376.376,0,0,1-.037-.436,9.657,9.657,0,0,0,1.057-2.551.376.376,0,0,1,.335-.283L73.1,63.5a.762.762,0,0,0,.7-.755V60.316a.762.762,0,0,0-.7-.755l-1.83-.147a.376.376,0,0,1-.335-.283,9.634,9.634,0,0,0-1.057-2.557.376.376,0,0,1,.037-.437l1.19-1.393a.761.761,0,0,0-.04-1.028L69.344,52a.757.757,0,0,0-1.027-.041l-1.4,1.189a.376.376,0,0,1-.436.037A9.66,9.66,0,0,0,63.93,52.13a.376.376,0,0,1-.283-.335l-.147-1.83a.762.762,0,0,0-.755-.7H60.318a.761.761,0,0,0-.755.7l-.147,1.83a.376.376,0,0,1-.283.335,9.662,9.662,0,0,0-2.554,1.054.376.376,0,0,1-.436-.037l-1.4-1.189A.757.757,0,0,0,53.721,52L52,53.717a.761.761,0,0,0-.04,1.028l1.19,1.392a.376.376,0,0,1,.037.437,9.636,9.636,0,0,0-1.057,2.557.376.376,0,0,1-.335.283l-1.83.147a.762.762,0,0,0-.7.755v2.428a.762.762,0,0,0,.7.755l1.83.147a.376.376,0,0,1,.335.283,9.657,9.657,0,0,0,1.057,2.551.376.376,0,0,1-.037.436l-1.192,1.4A.761.761,0,0,0,52,69.342l1.718,1.718a.757.757,0,0,0,1.028.04l1.4-1.193A.377.377,0,0,1,56.388,69.817Z" transform="translate(-48.518 -48.516)" /></g><g transform="translate(10.986 10.986)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M225.694,227.718a2.025,2.025,0,1,1,1.436-.594A2.017,2.017,0,0,1,225.694,227.718Zm0-3.3a1.272,1.272,0,1,0,.9.372A1.267,1.267,0,0,0,225.694,224.415Z" transform="translate(-223.666 -223.662)" /></g><g transform="translate(5.668 9.753)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M139.266,207.887a.376.376,0,0,1-.376-.363,7.427,7.427,0,0,1,.649-3.3.376.376,0,1,1,.686.31,6.67,6.67,0,0,0-.583,2.968.376.376,0,0,1-.363.389Z" transform="translate(-138.886 -203.998)" /></g><g transform="translate(7.709 5.668)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M171.794,141.659a.376.376,0,0,1-.266-.642,7.373,7.373,0,0,1,5.459-2.14.376.376,0,1,1-.027.752,6.614,6.614,0,0,0-4.9,1.92A.375.375,0,0,1,171.794,141.659Z" transform="translate(-171.418 -138.872)" /></g><g transform="translate(10.175 17.567)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M213.564,331.373a7.365,7.365,0,0,1-2.588-.469.376.376,0,0,1,.264-.7,6.628,6.628,0,0,0,7-1.508.376.376,0,0,1,.532.532A7.368,7.368,0,0,1,213.564,331.373Z" transform="translate(-210.732 -328.581)" /></g><g transform="translate(13.806 7.049)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M269,166.064a.376.376,0,0,1-.266-.642L273.154,161a.376.376,0,1,1,.532.532l-4.419,4.419A.375.375,0,0,1,269,166.064Z" transform="translate(-268.624 -160.892)" /></g><g transform="translate(9.798 14.145)"><path fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M205.108,276.111a.376.376,0,0,1-.266-.642l1.331-1.331a.376.376,0,1,1,.532.532L205.374,276A.375.375,0,0,1,205.108,276.111Z" transform="translate(-204.732 -274.027)" /></g></g></g></svg>
                            </div>
                            <div className={classes.stateContainer}>
                                <div className={classes.state}>
                                    {maintenance ? "MAINTENANCE" : "PRODUCTION"}
                                </div>
                            </div >
                            <div className={classes.expand}>
                                <ExpandMoreIcon className={classes.arrowIcon}></ExpandMoreIcon>
                            </div>
                        </Button>
                        :
                        <React.Fragment></React.Fragment>}
                        {props.productionOrder ? <React.Fragment>
                            <Button className={classes.stateButton} aria-describedby={id} onClick={handleClick}>
                                <div className={classes.stateIcon}>
                                    {state === orderState.RUNNING ?
                                        <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon> :
                                        state === orderState.PAUSED ?
                                            <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon> :
                                            state === orderState.STOPPED ?
                                                <div className={classes.stop}></div> :
                                                state === orderState.PLANNED ?
                                                    <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img> :
                                                    state === orderState.DONE ?
                                                        <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img> :
                                                        <React.Fragment></React.Fragment>
                                    }
                                </div>
                                <div className={classes.stateContainer}>
                                    <div className={classes.state}>
                                        {state}
                                    </div>
                                    <div className={classes.elapsed}>
                                        {props.productionOrder.productionOrderStatus === orderState.RUNNING && !create ? <Timer startTime={props.productionOrder.startedOn} {...props}></Timer> : <React.Fragment></React.Fragment>}
                                    </div>
                                </div >
                                <div className={classes.expand}>
                                    <ExpandMoreIcon className={classes.arrowIcon}></ExpandMoreIcon>
                                </div>
                            </Button>
                            <Popover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <ChangeStatePopoverContent state={state} changeState={changeState} popoverWidth={"20vw"}></ChangeStatePopoverContent>
                            </Popover>
                        </React.Fragment>
                            :
                            <React.Fragment>

                            </React.Fragment>}

                        <Popover
                            id={id2}
                            open={open2}
                            anchorEl={anchorEl2}
                            onClose={handleClose2}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <ChangeMaintenancePopoverContent changeMaintenance={changeMaintenance} maintenance={maintenance} popoverWidth={"20vw"}></ChangeMaintenancePopoverContent>
                        </Popover>
                    </div>
                    <div className={classes.editOrCreate}>
                        {!create ? <EditOrderComponent splitOrder={splitOrder} paused={props.productionOrder && props.productionOrder.productionOrderStatus === orderState.PAUSED} orderInfo={orderInfo} start={start} end={end} saveOrder={saveOrder} handleFromDateChange={handleFromDateChange} handleTillDateChange={handleTillDateChange}></EditOrderComponent> :
                            <CreateOrderComponent workstations={props.workstations} maintenance={maintenance} start={props.start} end={props.end} selectedWorkstation={props.selectedWorkstation} state={state} articles={props.articles} createOrder={props.createOrder} handleFromDateChange={handleFromDateChange} handleTillDateChange={handleTillDateChange} {...props}></CreateOrderComponent>}
                    </div>
                </React.Fragment> : <React.Fragment></React.Fragment>}
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "30%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px",
    },
    header: {
        width: "100%",
        height: "50px",
    },
    form: {
        width: "100%",
        height: "100%"
    },
    body: {
        width: "100%",
        height: "95%"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        display: "block",
        textAlign: "left",
        marginTop: "20px"
    },
    article: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        display: "block",
        textAlign: "left"
    },
    stateButton: {
        backgroundColor: "white",
        width: "100%",
        border: "1px solid #DEDEDE",
        marginTop: "20px",
        "&:hover": {
            background: "white"
        },
    },
    arrowIcon: {
        fill: "#020100",
        width: "20px",
        height: "20px"
    },
    stateIcon: {
        float: "left",
        width: "10%",
        marginRight: "20px"
    },
    stateContainer: {
        float: "left",
        width: "80%"
    },
    expand: {
        float: "right",
        width: "10%"
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px"
    },
    stop: {
        height: "20px",
        width: "20px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px"
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
        marginLeft: "5px"
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px"
    },
    planned: {
        marginRight: "10px",
        marginLeft: "5px"
    },
    done: {
        marginRight: "10px",
        marginLeft: "5px"
    },
    elapsed: {
        fontSize: "10px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        textAlign: "left"
    },
    state: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        textAlign: "left"
    },
    changeState: {
        backgroundColor: "white",
        width: "20vw"
    },
}));